const state = () => ({
    isMenuOpen: false,
    authenticateBeforeCheckout: true,
    hideScrollBar: false,
    alerts: [],
    currency: 'R',
    storeName: 'Eventos SBU-SP',
    notificationAnuidade: localStorage.getItem('n_Anuidade') || true,
    
})
  
const mutations = {
    TOGGLE_MENU(state, payload) {
        state.hideScrollBar = payload
        state.isMenuOpen = payload
    },
    SET_ALERT(state, alert){
        if(alert && alert.message != "Sessão expirada") {
            state.alerts.unshift(alert);
            setTimeout(() => {
                state.alerts.pop();
            }, 7000);
        }
    },
    REMOVE_ALERT(state, alertToRemove) {
        state.alerts = state.alerts.filter(alert => alert !== alertToRemove);
    },
    TOGGLE_NOTIFICATION_ANUIDADE(state) {
        localStorage.setItem('n_Anuidade', "visualizado");
        state.notificationAnuidade = "visualizado"
    },
}

const getters = {
    getIsMenuOpen: state => state.isMenuOpen,
    getAlerts: state => state.alerts,
    getNotificationAnuidade: state => state.notificationAnuidade
}

export default {
    state,
    getters,
    mutations
};